import NotificationWidget from './NotificationWidget';

export default NotificationWidget;
